import { NgModule } from '@angular/core';


import { BrowserModule } from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';


// shared Services an Pipes
import { InfoService } from '../providers/info.service';
import { StoreService } from '../providers/store.service';
import { AuthService } from '../providers/auth.service';

import { StorageServiceModule } from 'angular-webstorage-service';

// loader


@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    StorageServiceModule,


  ],
  declarations: [


  ],
  providers: [
    InfoService,
    StoreService,
    AuthService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },

  ],
  exports : [
    BrowserModule,
    HttpClientModule,
    StorageServiceModule,

    // InfoService,
    // StoreService,
    // AuthService,

  ]
})
export class RootsharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/rootshared.module.ts